import React, { useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classnames from 'classnames';
import { truncate } from 'lodash';
import { useMediaQuery } from '@material-ui/core';

import SvgIcon from '../../../components/SvgIcon';
import ImageDrop from '../../../components/ImageDrop/ImageDropChannels';
import Card from '../../channel/CardColourfulBold';
import {
  BUTTON_LIGHT_MODAL_STYLE_COLOURFUL,
  BUTTON_MODAL_STYLE_COLOURFUL,
  COLOURFUL_TEMPLATE_NAME,
  COMMENT_CHANNELS,
  IMAGE_ASPECT_RATIO_CH_COLOURFUN,
  IMAGE_ASPECT_RATIO_ONE,
  TITLE_MODAL_STYLE_COLOURFUL,
} from '../../../utils/const';
import PortfolioCommentIcon from '../../../components/PortfolioCommentIcon';
import SectionHeader from '../../../components/SectionHeader';
import { getColorDependsOnBackground } from '../../../utils/helpers/getColorDependsOnBackground';
import { getImageAspectRatio } from '../../../utils/helpers/getImageAspectRatio';

const ChannelsColourful = ({
  data: { description },
  locales,
  locales: {
    portfolio,
    channel: {
      intro: { card },
    },
  },
  background,
  firstSvgColor,
  secondSvgColor,
  buttonBackgroundColor,
  isFourthColorPaletteNumber = false,
  disabled = false,
}) => {
  const { collection } = useSelector((state) => state.channel);
  const [activeCardId, setActiveCardId] = useState(null);
  const {
    portfolio: { updateSectionField },
  } = useDispatch();

  const activeCardData = useMemo(() => {
    if (collection.length && !activeCardId) {
      setActiveCardId(collection[0].id);
      return collection[0];
    }
    return collection.find((i) => i.id === activeCardId);
  }, [collection, activeCardId]);

  const isSmallDesktop = useMediaQuery('(max-width: 1024px)');

  const singleCard = activeCardData && (
    <Card
      card={{
        ...card,
        ...activeCardData,
        title: null,
      }}
    />
  );

  const singleImage = activeCardData && (
    <ImageDrop
      locales={locales}
      dropzoneMode
      disabled={disabled}
      editMode={!disabled}
      templateName={COLOURFUL_TEMPLATE_NAME}
      aspectRatio={getImageAspectRatio(
        isSmallDesktop,
        IMAGE_ASPECT_RATIO_ONE,
        IMAGE_ASPECT_RATIO_CH_COLOURFUN,
      )}
      firstSvgColor={firstSvgColor}
      secondSvgColor={secondSvgColor}
      titleStyle={TITLE_MODAL_STYLE_COLOURFUL}
      buttonStyle={BUTTON_MODAL_STYLE_COLOURFUL}
      lightButtonStyle={BUTTON_LIGHT_MODAL_STYLE_COLOURFUL}
      isTemplates
      isColourfulfunTemplate
      card={{
        ...card,
        ...activeCardData,
        title: null,
      }}
    />
  );

  return (
    <div className="channel-colourful">
      <div className="left" style={{ backgroundColor: background }}>
        <div className="svg-funChannelsFirst" style={{ fill: firstSvgColor }}>
          <SvgIcon name="funChannelsFirst" />
        </div>
        <div className="svg-funChannelsSecond" style={{ fill: secondSvgColor }}>
          <SvgIcon name="funChannelsSecond" />
        </div>
        {singleImage}
      </div>
      <div className="right relative">
        <PortfolioCommentIcon title={COMMENT_CHANNELS} />
        <SectionHeader
          templateName={COLOURFUL_TEMPLATE_NAME}
          title={portfolio.channels.sectionTitle}
          description={description}
          onChange={(e) =>
            updateSectionField({
              sectionName: 'channels',
              field: 'description',
              name: 'channelsText',
              value: e.target.value,
            })
          }
          portfolio={portfolio}
          disabled={disabled}
        />

        <div className="cards-section">
          <div className="tabs">
            {collection.map(({ id, name }) => (
              <div
                key={id}
                onClick={() => setActiveCardId(id)}
                className={classnames(
                  'item',
                  {
                    active: activeCardId === id,
                  },
                  'custom-font-body',
                )}
                style={{
                  backgroundColor: activeCardId === id && buttonBackgroundColor,
                  color:
                    activeCardId === id &&
                    isFourthColorPaletteNumber &&
                    getColorDependsOnBackground(buttonBackgroundColor),
                }}
              >
                {truncate(name, { length: 30 })}
              </div>
            ))}
          </div>
          <div className="main">{singleCard}</div>
        </div>
      </div>
    </div>
  );
};

export default ChannelsColourful;
